import { Directive, OnDestroy, HostListener } from '@angular/core';
import { ParticipationComponent } from '../participation/participation.component';

@Directive({
  selector: '[appDestroy]'
})
export class DestroyDirective implements OnDestroy {

  constructor(private participation: ParticipationComponent) {
  }

  @HostListener('window:beforeunload')
  ngOnDestroy() {
    this.participation.onBeforeUnload();
  }
}
